<template>
  <div :class="total == 0 ? 'page nolist' : 'page'">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      style="min-height: 100vh"
    >
      <div>
        <div class="header-box">
          <img
            class="bgImg"
            src="https://cdn-xcxcustom.weiyoubot.cn/20210607/a6f7b4ac04fcc336ac516363fd433e8b.jpg"
          />
          <div class="header-bd">
            <div class="h-title">{{ title }}</div>
            <div class="h-total">{{ total }}位参与者</div>
          </div>
          <div class="header-rules" @click="showRulesInfo">
            <img
              src="https://cdn-xcxcustom.weiyoubot.cn/20210607/8b3e71e8197c19d72a5c58309f2e80ab.svg"
              class="icon-panel"
            />
            <span>规则说明</span>
          </div>
        </div>
        <div class="list-box">
          <div class="l-box-top">
            <div class="top-left">排名</div>
            <div class="top-right" v-if="temp == 2">总得分/累计天数</div>
            <div class="top-right" v-if="temp == 0 || temp == 1 || temp == 4">
              得分/时间
            </div>
            <div class="top-right" v-if="temp == 5">默契度</div>
          </div>

          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            @load="onLoad"
          >
            <div
              v-for="(item, index) in lists"
              :key="index"
              @click="is_owner ? toResult(item.rid) : ''"
            >
              <div
                :class="index < 3 ? 'list-bg list' : 'list'"
                @click.stop="is_owner ? toResult(item.rid) : ''"
              >
                <div class="i_1">
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/9461bb07da8b5bb6ee498b897827e47f.png"
                    v-if="item.rank == 1"
                  />
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/ae55b620eb805e7a6fc4799d3f4f12be.png"
                    v-else-if="item.rank == 2"
                  />
                  <img
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/824fe9c5000c0e0a2590fb0dc9f05285.png"
                    v-else-if="item.rank == 3"
                  />
                  <label v-else>{{ item.rank }}</label>
                </div>
                <div class="i_2">
                  <img
                    class="i_border"
                    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/16335c5a577101031827c607d23ffb0f.png"
                    v-if="index == 0"
                  />
                  <img
                    :class="
                      index == 2 || index == 1
                        ? 'border-white avatar'
                        : 'avatar'
                    "
                    mode="aspectFill"
                    :src="item.avatar"
                  />
                </div>
                <div
                  class="i_3"
                  @click.stop="is_owner ? toResult(item.rid) : ''"
                >
                  <div class="name">{{ item.alias }}</div>
                  <div class="time" v-if="temp != 2">{{ item.t_add }}</div>
                </div>
                <div
                  class="i_4"
                  v-if="temp == 2"
                  @click.stop="is_owner ? toResult(item.rid) : ''"
                >
                  <div class="score">{{ item.score }}</div>
                  <div>{{ item.total_days }}天</div>
                </div>
                <div
                  class="i_4"
                  v-else
                  @click.stop="is_owner ? toResult(item.rid) : ''"
                >
                  <div class="score">{{ item.score }}</div>
                  <div v-if="temp != 5">{{ item.time }}</div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
        <div
          class="noData"
          v-if="total == 0"
          style="color:#999;text-align:center;padding:rem(30) 0"
        >
          暂无人参与~
        </div>
      </div>
      <div
        class="tips"
        v-if="total && (total === lists.length || rank_limit <= lists.length)
        "
      >
        <div>加载完成，仅展示排行榜前{{ rank_limit }}名</div>
        <div v-if="(is_owner || is_vip) && rank_limit < 1000">
          如需展示更多，<span class="themeColor pointer position-r" @click="toEdit()"
            >前往设置<WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" /></span
          >修改展示人数，或下载全部排名查看
        </div>
        <div v-if="is_owner && rank_limit === 1000">
          可点击下方下载全部排名查看
        </div>
      </div>
    </van-pull-refresh>
    <div class="footer">
      <div
        class="uncheat-tip position-r"
        @click="toEdit()"
        v-if="(me.is_admin || me.is_owner) && !isInApp"
      >
        <div class="flexCenter">
          <img
            class="uncheat-tip-icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/4f91a85daa195a30cda2a42cb24d320d.svg"
            mode=""
          />对数据有疑问？
        </div>
        <span>点击查看防作弊数据 ></span>
        <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid"  />
      </div>
      <div class="list" @click="me.rank ? '' : 'back'" v-if="me.alias">
        <div class="i_1">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220329/9461bb07da8b5bb6ee498b897827e47f.png"
            v-if="me.rank == 1"
          />
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/ae55b620eb805e7a6fc4799d3f4f12be.png"
            v-else-if="me.rank == 2"
          />
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/824fe9c5000c0e0a2590fb0dc9f05285.png"
            v-else-if="me.rank == 3"
          />
          <label v-else>{{ me.rank ? me.rank : "?" }}</label>
        </div>
        <div class="i_2">
          <img
            class="i_border"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220328/16335c5a577101031827c607d23ffb0f.png"
            v-if="me.rank == 1"
          />
          <img
            :class="
              me.rank == 2 || me.rank == 3 ? 'border-white avatar' : 'avatar'
            "
            mode="aspectFill"
            :src="me.avatar"
          />
        </div>
        <div class="i_3">
          <div class="name">{{ me.alias }}</div>
          <div class="time" v-if="temp != 2">
            {{ me.t_add ? me.t_add : "答题后查看排名" }}
          </div>
        </div>
        <div class="i_4" v-if="!me.time" @click="toDetail">
          <div class="rules_top_item_title">剩余次数</div>
          <div
            :class="
              max_join_count ? 'rules_top_item_text' : 'rules_top_item_text f30'
            "
          >
            <template v-if="max_join_count"
              >{{ max_join_count
              }}<span class="sec-desc">/{{ max_join_count }}</span></template
            >
            <span v-else>无限制</span>
          </div>
        </div>
        <div class="i_4" v-else-if="temp == 2">
          <div class="score">{{ me.score }}</div>
          <div>{{ me.total_days }}天</div>
        </div>
        <div class="i_4" v-else>
          <div class="score">{{ me.score }}</div>
          <div v-if="temp != 5">{{ me.time }}</div>
        </div>
      </div>
      <div class="f-opt-box pointer">
        <div
          class="btn-que-download position-r"
          v-if="(is_owner == 1 || is_vip == 1 || me.is_admin) && !isInApp"
          @click="toSet()"
        >
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/4f4996595a23fe216ed104919649385e.svg"
          />
          <div>全部排名</div>
          <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid"  />
        </div>
        <div class="btn-que-index" v-else @click="toDetail">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/fdd6093604878d19cc14c0fd9619dfde.svg"
          />
          <div class="homeText">答题主页</div>
        </div>
        <div class="btn-que-share" @click="share" v-if="allow_share">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/9ecc67aa6b2d800921ad729d8d7aa0e4.svg"
          />
          <div>分享</div>
        </div>
        <div class="btn-que-again" @click="toDetail" v-if="temp == 5">
          <div>开始测试</div>
        </div>
        <div class="btn-que-again" @click="toDetail" v-else>
          <div>{{ !me.time ? "立即答题" : "再答一次" }}</div>
        </div>
      </div>
    </div>
    <HomeIcon />
    <van-popup
      v-model="shareVisible"
      position="bottom"
      duration="0.1"
      :style="{ borderRadius: '4px 4px 0 0', background: 'transparent' }"
    >
      <manage-footer
        :info="info"
        :visible="shareVisible"
        @hideVisible="handleShareVisible"
      ></manage-footer>
    </van-popup>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="settingSrc" />
    </van-popup>
    <TipDialog
      @hideConfirm="hideConfirm"
      :visible="showRankInfo"
      :content="rankInfo"
    />
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import {
  formatDate,
  formatMinuteNew,
  getToken,
  setShareInfo,
  reLogin,
  isMobile,
  isWeixin,
  getWxUrl,
  getDetailWxCode,
  jumpVip,
  vipClick
} from "@/utils/common";
import NavBar from "@/components/navbar";
import HomeIcon from "@/components/homeIcon";
import ManageFooter from "@/components/manageFooter.vue";
import ImgDialog from "@/components/common/imgDialog.vue";
import TipDialog from "../../components/common/tipDialog.vue";
import WxLink from "@/components/wxLink.vue";

export default {
  components: { NavBar, HomeIcon, ManageFooter, ImgDialog, TipDialog, WxLink },
  data() {
    return {
      showVersionTip: false,
      shareVisible: false,
      qid: "",
      page: 1,
      lists: [],
      temp: 4,
      me: {},
      total: 0,
      banner: "",
      title: "",
      is_owner: 0,
      is_vip: 0,
      refreshing: false,
      loading: false,
      finished: false,
      pageSize: 20,
      rank_limit: 1000,
      allow_share: true,
      isInApp: wemeet.app.isTMWebview(),
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      info: {},
      settingUrl: "",
      settingSrc: '',
      owner: "",
      showRankInfo: false,
      rankInfo: [],
      enterprise_vip: 0,
      max_join_count: 0,
      wxPath: '/pages/detail/detail?qid='
    };
  },
  methods: {
    hideConfirm() {
      this.showRankInfo = false;
    },
    toSet() {
      if (this.enterprise_vip) {
        this.toEdit();
      } else {
        if (this.me.admin_user) {
          Dialog.alert({
            title: "",
            message: "当前版本不支持使用该功能，请联系出题人处理",
            showCancelButton: false,
            confirmButtonColor: "#1890ff",
            confirmButtonText: "我知道了"
          }).then(() => {});
          return;
        }
        Dialog.confirm({
          message:
            "仅高级版用户可以使用「下载全部排名」功能以及其他高级版权益。",
          confirmButtonColor: "#1890FF",
          confirmButtonText: "立即前往",
          cancelButtonText: "我知道了"
        }).then(() => {
          vipClick("down_rank", "下载全部排名", 1);
          jumpVip(this);
        });
      }
    },
    async toEdit() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        if (!this.settingSrc) {
          let res = await getDetailWxCode(this.qid);
          if (res) {
            this.settingSrc = res;
          }
        }
        this.showVersionTip = true;
      }
    },
    handleShareVisible() {
      this.shareVisible = false;
    },
    showRulesInfo() {
      let content = [];
      if (this.temp == 2) {
        content = [
          "1. 得分（每天最好的成绩总和）越高越前；",
          "2. 得分一致时，参与天数越多越前；",
          "3. 得分/天数一致，按最新提交的一次记录，提交时间越早越前；",
          `排行榜实时更新，榜单展示前${this.rank_limit}名`
        ];
      } else {
        content = [
          "仅得分最高的1次记录参与排行",
          "1. 得分（得分越高排名越前）",
          "2. 用时（得分一致，用时越短越前）",
          "3. 提交时间（得分用时一致，提交时间越早越前）",
          `排行榜实时更新，榜单展示前${this.rank_limit}名`
        ];
      }
      this.rankInfo = content;
      this.showRankInfo = true;
    },
    toResult(rid) {
      if (this.rank_rec && rid && this.temp === 5) {
        this.$router.push({ name: "answerTacit", query: { rid } });
      }
    },
    onRefresh() {
      this.getRank(1, "chageType");
    },
    onLoad() {
      this.getRank(this.page + 1);
    },
    getRank(page = 1, changeType) {
      if (page === 11) return;
      this.page = page;
      let param = {
        qid: this.qid,
        access_token: getToken(),
        count: this.pageSize,
        page: this.page
      };
      questionOnly.get(api.question.getRank, param).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          let r = res.data;
          const l = r.lists.reduce((r, c) => {
            c.t_add = formatDate(new Date(c.t_add * 1000), "yyyy-MM-dd HH:mm");
            c.time = formatMinuteNew(c.time);
            return [...r, c];
          }, []);
          if (r.me.t_add) {
            r.me.t_add = formatDate(
              new Date(r.me.t_add * 1000),
              "yyyy-MM-dd HH:mm"
            );
            r.me.time = formatMinuteNew(r.me.time);
          }
          if (!r.lists.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          let curList = changeType ? l : this.lists.concat(l);
          if (curList.length >= r.rank_limit) {
            curList = curList.splice(0, r.rank_limit);
            this.finished = true;
          }
          if (curList.length == r.total) {
            this.finished = true;
          }
          this.lists = curList;
          this.me = r.me;
          this.total = r.total;
          this.temp = r.temp;
          this.title = r.title;
          this.owner = r.owner;
          this.is_owner = r.me.is_owner;
          this.is_vip = r.me.is_admin || "";
          this.rank_rec = r.rank_rec;
          this.rank_limit = r.rank_limit;
          this.enterprise_vip = r.enterprise_vip;
          this.max_join_count = r.max_join_count;
          // 判断是否可分享
          if (r.allow_share == 1) {
            this.setShare(false);
          } else {
            if (r.me.is_admin == 1 || r.me.is_ower == 1) {
              this.setShare(true);
            } else {
              this.allow_share = false;
              this.setShare(false);
            }
          }
        } else if (res.sta === -500) {
          this.handleErr();
        } else {
          Toast(res.msg);
        }
      });
    },
    setShare(type) {
      if (type) {
        setShareInfo(true, "排行榜新鲜出炉，快来点击围观吧！");
      } else {
        setShareInfo(false);
      }
    },
    share() {
      if (this.isInApp) {
        wemeet.app.shareOpenApp();
      } else {
        // wait wait
        this.shareVisible = true;
      }
    },
    toDetail() {
      let name = this.temp == 5 ? "tacitDetail" : "normalDetail";
      this.$router.push({ name: name, query: { qid: this.qid } });
    },
    handleErr() {
      if (this.isInApp) {
        localStorage.setItem(
          "rank",
          JSON.stringify({
            qid: this.qid
          })
        );
      }
      reLogin("rank");
    }
  },
  mounted() {
    this.qid = this.$route.query.qid;
    this.info = {
      qid: this.$route.query.qid
    };
    this.getRank();
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  min-height: 100vh;
  height: auto;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
}
.page.nolist {
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 0;
}
.header-box {
  position: relative;
  width: 100%;
  height: rem(310);
  padding: rem(30);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: unset;
}
.header-box .bgImg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.header-bd {
  position: relative;
  z-index: 20;
  width: rem(400);
  padding-top: rem(86);
}
.header-rules {
  color: #fff;
  z-index: 3;
  font-size: rem(26);
  display: inline-flex;
  align-items: center;
  height: rem(39);
  line-height: rem(39);
  cursor: pointer;
}
.header-rules img {
  width: rem(36);
  height: rem(36);
  margin-right: rem(10);
  margin-top: rem(4);
}
.header-rules text {
  font-weight: bold;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}
.h-title {
  font-size: rem(40);
  font-weight: bold;
  color: #fff;
  text-shadow: rem(1) rem(1) rem(6) rgba(0, 29, 63, 0.5);

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.h-total {
  font-size: rem(26);
  color: #fff;
  padding-top: rem(6);
}
.list-box {
  position: relative;
  // z-index: 10;
  padding: rem(60) rem(30) rem(30);
  position: relative;
  top: rem(0);
  margin-top: -10px;
  border-radius: rem(20) rem(20) 0 0;
  box-sizing: border-box;
  background: #ffffff;
}
.l-box-top {
  position: absolute;
  top: -1px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 rem(30);
  width: rem(690);
}
.l-box-top div {
  font-size: rem(26);
  color: #fff;
  font-weight: 900;
  background: #1372fb;
  height: rem(40);
  line-height: rem(40);
  text-align: center;
  padding: 0 rem(20);
  border-radius: 0;
  border-radius: 0 0 rem(10) rem(10);
}
.list {
  height: rem(150);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  cursor: pointer;
  /* border-bottom: 1rem() solid #eee; */
}
.list-bg {
  background: #f2fafa;
  border-bottom: 0;
  margin-bottom: rem(20);
  border-radius: rem(10);
}
.i_1 {
  min-width: rem(80);
  white-space: nowrap;
  padding-right: rem(10);
  text-align: center;
}
.i_1 img {
  width: rem(54);
  height: rem(54);
}

.i_2 {
  position: relative;
}
.i_2 .avatar {
  position: relative;
  z-index: 2;
  width: rem(90);
  height: rem(90);
  border-radius: 50%;
  margin-right: rem(30);
  margin-left: rem(15);
  margin-top: rem(15);
}
.border-white {
  border: rem(4) solid #fff;
}
.i_border {
  position: absolute;
  z-index: 1;
  width: rem(120);
  height: rem(120);
}

.i_3 {
  flex: 1;
}
.i_3 .name {
  font-size: rem(30);
  color: #333;
  line-height: 1.7;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.i_3 .time {
  font-size: rem(26);
  color: #999;
}

.i_4 {
  width: rem(160);
  font-size: rem(24);
  color: #666;
  text-align: center;
}
.i_4 .score {
  font-size: rem(36);
  font-weight: bold;
  color: #1890ff;
}
.total {
  height: rem(60);
  line-height: rem(60);
  text-align: center;
  color: #999;
  font-size: rem(26);
  background-color: #f2f2f7;
}
.limit_info {
  text-align: center;
  color: #999;
}
.noData {
  // padding: 64px rem(30) rem(30);
  margin: rem(20) 0 rem(300);
  font-size: rem(26);
}

.footer {
  position: fixed;
  background-color: #fff;
  border-radius: rem(20) rem(20) 0 0;
  box-shadow: rem(-1) rem(-1) rem(18) rgba(196, 194, 194, 0.42);
  bottom: 0;
  left: auto;
  width: 100%;
  max-width: 500px;
  z-index: 3;
  box-sizing: content-box;
}
.footer .list {
  margin: 0 rem(30);
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  border: 0;
}

.btn-blue {
  width: rem(135);
  height: rem(50);
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  font-size: rem(32);
  background-color: #1890ff;
  color: #fff;
  border-radius: rem(6);
}
.f-opt-box {
  margin: 0 rem(30);
  display: flex;
  align-items: center;
  height: rem(120);
}
.btn-que-index,
.btn-que-share,
.btn-que-download {
  width: rem(100);
  text-align: center;
  font-size: rem(24);
  color: #666;
  line-height: 1.6;
  margin-right: rem(15);
}
.btn-que-index {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-que-index img,
.btn-que-share img,
.btn-que-download img {
  width: rem(40);
  height: rem(40);
  display: block;
  margin: 0 auto rem(6);
}
.btn-que-again {
  flex: 1;
  height: rem(80);
  line-height: rem(80);
  border-radius: rem(40);
  background: #1890ff;
  color: #fff;
  font-size: rem(32);
  font-weight: 900;
  text-align: center;
}
.limit_info {
  text-align: center;
  color: #999;
  font-size: rem(26);
}
.homeText {
  min-width: rem(120);
}
.tips {
  color: #999;
  text-align: center;
  margin: rem(30) 0 rem(360);
  font-size: rem(26);
}

.uncheat-tip {
  height: rem(70);
  line-height: rem(70);
  border-radius: rem(20) rem(20) 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #313238;
  font-size: rem(24);
  color: #f0c89d;
  padding: 0 rem(40);
  cursor: pointer;
}

.uncheat-tip-icon {
  width: rem(40);
  height: rem(40);
  margin-right: rem(20);
}

.rules_top_item_title {
  font-size: rem(26);
  line-height: rem(36);
  color: #999999;
}
.rules_top_item_text {
  font-weight: 700;
  font-size: rem(36);
  line-height: rem(54);
  color: #262626;
}
.f30 {
  font-size: rem(30) !important;
}
.sec-desc {
  color: #999999;
  font-size: rem(24);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/rank/rank.vue